import {useIntl} from 'react-intl'

export const investorUpdateBreadCrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
export const investorPitchDeckBreadCrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Investor Updates',
    path: '/updates/update',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
export const investorPitchDeckPDFBreadCrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Investor Updates',
    path: '/updates/update',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Pitch Deck',
    path: '/updates/pitch-deck',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
export const createUpdatesBreadCrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Investor Updates',
    path: '/updates/update',
    isSeparator: false,
    isActive: false,
  },
]

export const editUpdatesBreadCrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Investor Updates',
    path: '/updates/update',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const updatesInitialValues = {
  updateTitle: '',
  updateTimeframe: '',
}

export const investorUpdateFilterConst = [
  // {id: 101, name: 'Select status', value: '', disabled: true},
  {id: 102, name: 'Draft', value: 'DRAFT'},
  {id: 103, name: 'Published', value: 'PUBLISHED'},
]
export const pitchDeckFilterConst = [
  // {id: 104, name: 'Select status', value: '', disabled: true},
  {id: 105, name: 'Draft', value: 'DRAFT'},
  {id: 106, name: 'Published', value: 'PUBLISHED'},
]
export const templateFilterConst = [
  // {id: 111, name: 'Select status', value: '', disabled: true},
  {id: 112, name: 'Draft', value: 'DRAFT'},
  {id: 113, name: 'Published', value: 'PUBLISHED'},
]

export const investorUpdateKpiTypeConst = [
  {id: 33, name: 'Select type', value: '', disabled: true},
  {id: 34, name: 'Currency', value: 'Currency'},
  {id: 35, name: 'Percentage', value: 'Percentage'},
  {id: 36, name: 'Number', value: 'Number'},
]

export const sectionDataConstant = [
  {
    type: 'richText',
    inputText: '',
    richText: '',
  },
  {
    type: 'documents',
    inputText: '',
    ids: [],
  },
  {
    type: 'kpiValues',
    currencyType: '$',
    kpiValues: [
      {
        id: 0,
        toogle: false,
        title: 'MRR (Monthly Recurring Revenue)',
        value: '',
        type: '',
      },
      {
        id: 1,
        toogle: false,
        title: 'ARR (Annual Recurring Revenue)',
        value: '',
        type: '',
      },
      {
        id: 2,
        toogle: false,
        title: 'Cash Balance',
        value: '',
        type: '',
      },
      {
        id: 3,
        toogle: false,
        title: 'Monthly Burn Rate',
        value: '',
        type: '',
      },
      {
        id: 4,
        toogle: false,
        title: 'MAU (Monthly Active Users)',
        value: '',
        type: '',
      },
      {
        id: 6,
        toogle: false,
        title: 'Remaining Runway Months',
        value: '',
        type: '',
      },
      {
        id: 7,
        toogle: false,
        title: 'Customers',
        value: '',
        type: '',
      },
      {
        id: 8,
        toogle: false,
        title: 'LTV (Lifetime Value)',
        value: '',
        type: '',
      },
      {
        id: 9,
        toogle: false,
        title: 'CAC (Customer Acquistion Cost)',
        value: '',
        type: '',
      },
      {
        id: 10,
        toogle: false,
        title: 'Churn',
        value: '',
        type: '',
      },
      {
        id: 11,
        toogle: false,
        title: 'NPS (Net Promoter Score)',
        value: '',
        type: '',
      },
      {
        id: 12,
        toogle: false,
        title: 'Employees',
        value: '',
        type: '',
      },
    ],
  },
]

export const SendEmailUpdateBreadCurmbs = () => {
  const {formatMessage} = useIntl()

  const investorUpdateBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const investorPitchDeckBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Investor Updates'}),
      path: '/updates/update',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const investorPitchDeckPDFBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Investor Updates'}),
      path: '/updates/update',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Pitch Deck'}),
      path: '/updates/pitch-deck',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const createUpdatesBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Investor Updates'}),
      path: '/updates/update',
      isSeparator: false,
      isActive: false,
    },
  ]

  const editUpdatesBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Investor Updates'}),
      path: '/updates/update',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const sendEmailBreadCrumbs = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Send Emails'}),
      path: '/updates/send-emails',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return {
    sendEmailBreadCrumbs,
    investorUpdateBreadCrumbs,
    investorPitchDeckBreadCrumbs,
    createUpdatesBreadCrumbs,
    investorPitchDeckPDFBreadCrumbs,
    editUpdatesBreadCrumbs,
  }
}
export const Investors = {
  EXISTING: 'existing',
  PROSPECTIVE: 'prospective',
}

export interface Investor {
  angellist_url: string
  blog_url: string
  email: string
  name: string
  phone: string
  company: string
  investorId: number
  checked: boolean
  greeting: string
  greetingName: string
  file: {
    companyId: number
    createdAt: string
    deletedAt: string | null
    fileId: number
    isProtected: boolean
    module: string
    name: string
    updatedAt: string
    userId: number
  }
}

export const InvestorRelationFilter = () => {
  const intl = useIntl()
  const investorUpdateFilterConst = [
    // {id: 101, name: 'Select status', value: '', disabled: true},
    {id: 102, name: intl.formatMessage({id: 'Draft'}), value: 'DRAFT'},
    {id: 103, name: intl.formatMessage({id: 'Published'}), value: 'PUBLISHED'},
  ]
  const pitchDeckFilterConst = [
    // {id: 104, name: 'Select status', value: '', disabled: true},
    {id: 105, name: intl.formatMessage({id: 'Draft'}), value: 'DRAFT'},
    {id: 106, name: intl.formatMessage({id: 'Published'}), value: 'PUBLISHED'},
  ]
  const templateFilterConst = [
    // {id: 111, name: 'Select status', value: '', disabled: true},
    {id: 112, name: intl.formatMessage({id: 'Draft'}), value: 'DRAFT'},
    {id: 113, name: intl.formatMessage({id: 'Published'}), value: 'PUBLISHED'},
  ]
  const emailFilterConst = [
    {id: 108, name: intl.formatMessage({id: 'Select Status'}), value: '', disabled: true},
    {id: 109, name: intl.formatMessage({id: 'Draft'}), value: 'DRAFT'},
    {id: 110, name: intl.formatMessage({id: 'READY'}), value: 'READY'},
    {id: 111, name: intl.formatMessage({id: 'SENT'}), value: 'SENT'},
    {id: 112, name: intl.formatMessage({id: 'PART SENT'}), value: 'PART SENT'},
  ]
  return {
    emailFilterConst,
    investorUpdateFilterConst,
    pitchDeckFilterConst,
    templateFilterConst,
  }
}
